export default __webpack_public_path__ + "static/media/The Fee.6aabb9b6.png";